import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import categoryService from '../../services/category.service';

export const addCategory = createAsyncThunk('categorySlice/addCategory', async (params, thunkAPI) => {
  try {
    const data = await categoryService.addCategoryAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateCategory = createAsyncThunk('categorySlice/updateCategory', async (params, thunkAPI) => {
  try {
    const data = await categoryService.updateCategoryAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getCategory = createAsyncThunk('categorySlice/getCategory', async (thunkAPI) => {
  try {
    const data = await categoryService.getCategoryAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteCategory = createAsyncThunk('categorySlice/deleteCategory', async (params, thunkAPI) => {
  try {
    const data = await categoryService.deleteCategoryAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const selectedCategory = createAsyncThunk('categorySlice/selectedCategory', async (params, thunkAPI) => {
  try {
    const data = await categoryService.selectedCategoryAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getSubCategory = createAsyncThunk('categorySlice/getSubCategory', async (thunkAPI) => {
  try {
    const data = await categoryService.getSubCategoryAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const addSubCategory = createAsyncThunk('categorySlice/addSubCategory', async (params, thunkAPI) => {
  try {
    const data = await categoryService.addSubCategoryAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateSubCategory = createAsyncThunk('categorySlice/updateSubCategory', async (params, thunkAPI) => {
  try {
    const data = await categoryService.updateSubCategoryAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteSubCategory = createAsyncThunk('categorySlice/deleteSubCategory', async (params, thunkAPI) => {
  try {
    const data = await categoryService.deleteSubCategoryAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getSubtoSubDetails = createAsyncThunk('categorySlice/getSubtoSubDetails', async (params, thunkAPI) => {
  try {
    const data = await categoryService.getSubtoSubAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const addSubtoSubDetails = createAsyncThunk('categorySlice/addSubtoSubDetails', async (params, thunkAPI) => {
  try {
    const data = await categoryService.addSubtoSubAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getTreeList = createAsyncThunk('categorySlice/getTreeList', async (params, thunkAPI) => {
  try {
    const data = await categoryService.getTreeListAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateSubToSub = createAsyncThunk('categorySlice/updateSubToSub', async (params, thunkAPI) => {
  try {
    const data = await categoryService.updateSubtoSubAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  categoryList: [],
  subCategoryList: [],
  selectedCategoryList: [],
  subToSubList: [],
  treeList: []
};

const categorySlice = createSlice({
  name: 'categorySlice',
  initialState,
  extraReducers: {
    [getCategory.fulfilled]: (state, action) => {
      state.categoryList = action.payload.data;
    },
    [selectedCategory.fulfilled]: (state, action) => {
      state.selectedCategoryList = action.payload.data;
    },
    [getSubCategory.fulfilled]: (state, action) => {
      state.subCategoryList = action.payload.data;
    },
    [getSubtoSubDetails.fulfilled]: (state, action) => {
      state.subToSubList = action.payload.data;
    },
    [getTreeList.fulfilled]: (state, action) => {
      state.treeList = action.payload.data;
    }
  }
});

const { reducer } = categorySlice;
export default reducer;
